export default class IoaWorkbenchError extends Error {}
